import { modalContainerStyle } from '~/components/styles';

export const removeButtonStyles = {
  backgroundColor: 'error.main',
  '&:hover': {
    backgroundColor: 'error.dark',
  },
  '&:active': {
    backgroundColor: 'error.light',
  },
};

export const removeUserModalContainerStyles = {
  ...modalContainerStyle,
  borderTop: '8px solid',
  borderTopColor: 'error.main',
};

const avatarBaseSx = {
  height: 48,
  width: 48,
  border: 'none',
  position: 'relative',
  zIndex: 1,

  '& svg': {
    height: '24px !important',
    width: '24px !important',
  },
};

export const activeAvatarSx = {
  ...avatarBaseSx,
  bgcolor: 'primary.main',
  border: '2px solid #140f4b',
  color: '#fff',
};

export const disabledAvatarSx = {
  ...avatarBaseSx,
  bgcolor: 'transparent',
  color: 'rgba(0, 0, 0, 0.38)',
  border: '2px solid #0000004D',
};

export const stepLabelSx = {
  '& .MuiStepLabel-label': {
    fontSize: '1.6rem',
    color: 'rgba(0, 0, 0, 0.6)',

    '&.MuiStepLabel-alternativeLabel': {
      mt: 0.5,
    },
    '&.Mui-active': {
      color: 'primary.main',
      fontWeight: 700,
    },
    '&.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
    },
  },
};

export const stepperSx = {
  px: 3,
  pt: 1,
  pb: 2,

  // Steps: align the first label to the left edge, the last label to the right edge
  '& .MuiStep-root.MuiStep-horizontal.MuiStep-alternativeLabel': {
    '&:first-of-type .MuiBox-root': {
      alignItems: 'flex-start',
    },
    '&:first-of-type .MuiStepLabel-root': {
      alignItems: 'flex-start',
    },
    '&:first-of-type .MuiStepLabel-iconContainer': {
      pl: 2,
    },
    '&:last-of-type .MuiBox-root': {
      alignItems: 'flex-end',
    },
    '&:last-of-type .MuiStepLabel-root': {
      alignItems: 'flex-end',
    },
    '&:last-of-type .MuiStepLabel-iconContainer': {
      pr: 2,
    },
  },

  '& .MuiStepConnector-root': {
    zIndex: 0,
  },
  '& .MuiStepConnector-alternativeLabel': {
    top: 24,
    left: 'calc(-50% + 26px)',
    right: 'calc(50% + 26px)',
  },
  '& .MuiStepConnector-line': {
    borderTopWidth: 2,
    borderColor: '#0000004D',
  },

  // Connectors: stretch the outer ends to reach the flush edge icons
  '& .MuiStep-root:nth-of-type(2) .MuiStepConnector-root': {
    left: 'calc(-100% + 74px)',
  },
  '& .MuiStep-root:last-of-type .MuiStepConnector-root': {
    right: '74px',
  },
};
